import api from "../../api/datadash";
import router from "../../router";

const state = {
  error: "",
  success: "",
  statusCode: "",
  errorMsg: "",
  indexData: [],
  indexDataLoading: true,
  projectStatusCount: [],
  subscriptionData: [],
  projectId: "",
  test: [],
  availableDasher: null,
};
const getters = {
  error: (state) => {
    return state.error;
  },
  success: (state) => {
    return state.success;
  },
  statusCode: (state) => {
    return state.statusCode;
  },
  errorMsg: (state) => {
    return state.errorMsg;
  },
  indexData: (state) => {
    return state.indexData;
  },
  indexDataLoading: (state) => {
    return state.indexDataLoading;
  },
  projectStatusCount: (state) => {
    return state.projectStatusCount;
  },
  subscriptionData: (state) => {
    return state.subscriptionData;
  },
  projectId: (state) => {
    return state.projectId;
  },
  //for testing purpose
  test: (state) => {
    return state.test;
  },
  availableDasher: (state) => {
    return state.availableDasher;
  },
};

const actions = {
  async indexData({ rootState, commit }, parameters) {
    // commit('setTest', parameters)
    const { token } = rootState.auth;
    const response = await api.fetchAllData(
      token,
      parameters[0],
      parameters[1]
    );
    commit("setData", response);
  },
  async projectStatusCount({ rootState, commit }, parameters) {
    const { token } = rootState.auth;
    const response = await api.fetchData(token, parameters[0]);
    commit("setProjectStatusCount", response);
  },
  async subscriptionData({ rootState, commit }, parameters) {
    // commit('setTest', parameters)
    const { token } = rootState.auth;
    const response = await api.fetchData(token, "subscription-features");
    commit("setSubscriptionData", response);
  },
  async indexDataAndRout({ rootState, commit }, parameters) {
    // commit('setTest', parameters)
    const { token } = rootState.auth;
    const response = await api.fetchAllData(
      token,
      parameters[0],
      parameters[1]
    );
    commit("setData", response);
    router.push(parameters[2]);
  },

  async paymentPage({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.fetchAllData(
      token,
      parameters[0],
      parameters[1]
    );
    commit("setData", response);
    if (response.data.error == 0) {
      window.localStorage.setItem("projectId", parameters[1]);
      router.push("/payment-page").catch((err) => err);
    } else {
      router.push("/project-details");
    }
  },

  async remainingPaymentPage({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.fetchAllData(
      token,
      parameters[0],
      parameters[1]
    );
    commit("setData", response);
    if (response.data.error == 0) {
      window.localStorage.setItem("projectId", parameters[1]);
      router.push("/remaining-payment-page").catch((err) => err);
    } else {
      router.push("/project-details");
    }
  },

  async paymentMethod({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.fetchAllData(
      token,
      parameters[0],
      parameters[1]
    );
    commit("setData", response);
  },

  async remainingPaymentMethod({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.fetchAllData(
      token,
      parameters[0],
      parameters[1]
    );
    commit("setData", response);
  },

  async responseDataCoins({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.fetchAllData(
      token,
      parameters[0],
      parameters[1]
    );
    commit("setData", response);
    window.localStorage.setItem("projectId", parameters[1]);
  },

  async responseData({ rootState, commit }, parameters) {
    // commit('setTest', parameters);
    const { token } = rootState.auth;
    const response = await api.fetchResponseData(
      token,
      parameters[0],
      parameters[1],
      parameters[2]
    );
    commit("setData", response);
  },

  async setIndexData({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.fetchData(token, parameters[0]);
    commit("setData", response);
  },

  async store({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    commit("setData", response);
    // router.push('/budget')
  },

  async storeImage({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    commit("setTest", response);
    // router.push('/budget')
  },

  async scheduleProject({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    commit("setData", response);
    if (response.data.error == 0) {
      router.push("/all-project");
    } else {
      router.push("/success-pay");
    }
  },

  async storeOrUpdate({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    commit("setData", response);
    // console.log(response);
  },
  async storeOrUpdateProject({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    if (response.status == 200) {
      commit("setData", response);
      // console.log(response);

      if (response.data.data.project.id > 0) {
        localStorage.setItem(
          "project_id",
          JSON.stringify(response.data.data.project.id)
        );
        localStorage.setItem(
          "project_status_id",
          response.data.data.project.project_status_id
        );

        // localStorage.setItem("project_id_edit", null);

        if (response.data.data.project.project_type_id == 2) {
          const responseData = await api.fetchAllData(
            token,
            "response-location",
            response.data.data.project.id
          );
          commit("setData", responseData);
          if (response.status == 200) {
            router.push("/address");
          }
        } else {
          if (response.status == 200) {
            if (response.data.data.project.has_pre_survey == 1) {
              const responseData = await api.fetchAllData(
                token,
                "pre-survey-question-json",
                response.data.data.project.id
              );
              commit("setData", responseData);
              router.push("/pre-survey-question");
            } else {
              const responseData = await api.fetchAllData(
                token,
                "question-json",
                response.data.data.project.id
              );
              commit("setData", responseData);
              router.push("/dynamic-question");
            }
          }
        }
      }
    }
  },
  async storeOrUpdateAddress({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    if (response.status == 200) {
      commit("setData", response);
      if (response.data.data.datas.has_pre_survey == 1) {
        const responseData = await api.fetchAllData(
          token,
          "pre-survey-question-json",
          response.data.data.datas.id
        );
        commit("setData", responseData);
        router.push("/pre-survey-question");
      } else {
        const responseData = await api.fetchAllData(
          token,
          "question-json",
          response.data.data.datas.id
        );
        commit("setData", responseData);
        router.push("/dynamic-question");
      }
    }
  },

  async storeOrUpdatePreSurveyQuestion({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    if (response.status == 200) {
      commit("setData", response);
      const responseData = await api.fetchAllData(
        token,
        "question-json",
        response.data.data.project_id
      );
      commit("setData", responseData);
      if (response.status == 200) {
        router.push("/dynamic-question");
      }
    }
  },

  async storeOrUpdateQuestion({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    if (response.status == 200) {
      commit("setData", response);
      // const responseData = await api.fetchAllData( token, "project-dasher-category", response.data.data.project_id);
      // commit("setData", responseData);
      if (
        response.status == 200 &&
        response.data.data.datas.project_type_id === 3 &&
        response.data.data.datas.agent_option === 3
      ) {
        router.push("/budget");
      } else if (
        response.status == 200 &&
        response.data.data.datas.project_type_id === 3
      ) {
        router.push("/assign-agent-groups-to-project");
      } else {
        router.push(`/${response.data.data.project_id}/project-settings`);
      }
      // if (
      //   response.status == 200 &&
      //   response.data.data.datas.project_type_id === 3
      // ) {
      //   router.push("/assign-agent-groups-to-project");
      // } else if (response.status == 200) {
      //   router.push(`/${response.data.data.project_id}/project-settings`);
      // }
    }
  },

  async storeOrUpdateTeamAssignment({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    if (response.status == 200) {
      commit("setData", response);
      if (response.status == 200) {
        if (response.data.data.datas.project_type_id == "1") {
          const responseData = await api.fetchAllData(
            token,
            "project-info",
            response.data.data.datas.id
          );
          commit("setData", responseData);
          if (responseData.status == 200) {
            router.push("/budget");
          }
        } else {
          const responseData = await api.fetchAllData(
            token,
            "project-info",
            response.data.data.datas.id
          );
          commit("setData", responseData);
          if (responseData.status == 200) {
            router.push("/budget2");
          }
        }
      }
    }
  },

  async storeOrUpdateProjectAgentAssignment({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    // console.log(response);
    if (response.status == 200) {
      commit("setData", response);
      if (response.status == 200) {
        // const responseData = await api.fetchAllData( token, "project-info", response.data.data.datas.id);
        // commit("setData", responseData);
        // console.log(responseData);
        // if (responseData.status == 200) {
        if (response.data.data.datas.agentTaskAssignmentMethod == 3) {
          router.push("/define-project-task-to-agents");
        } else {
          router.push("/budget");
        }
        // }
      }
    }
  },

  async storeOrUpdateProjectAgentTaskDefine({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    // console.log(response);
    if (response.status == 200) {
      commit("setData", response);
      if (response.status == 200) {
        const responseData = await api.fetchAllData(
          token,
          "project-info",
          response.data.data.datas.id
        );
        commit("setData", responseData);
        if (responseData.status == 200) {
          router.push("/budget");
        }
      }
    }
  },

  async storeOrUpdateAgentTaskDefine({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    // console.log(response);
    if (response.status == 200) {
      commit("setData", response);
      if (response.status == 200) {
        const responseData = await api.fetchAllData(
          token,
          "project-info",
          response.data.data.datas.id
        );
        commit("setData", responseData);
        // if (responseData.status == 200) {
        //   router.push("/budget");
        // }
      }
    }
  },
  async storeOrUpdateProjectAgentTaskDefineModify(
    { rootState, commit },
    parameters
  ) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    // console.log(response);
    if (response.status == 200) {
      commit("setData", response);
      if (response.status == 200) {
        const responseData = await api.fetchAllData(
          token,
          "project-info",
          response.data.data.datas.id
        );
        commit("setData", responseData);
        if (responseData.status == 200) {
          router.push("/edit-budget");
        }
      }
    }
  },

  async storeOrUpdateFilterDasher({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    // console.log(response);
    if (response.status == 200) {
      commit("setData", response);
      if (response.status == 200) {
        if (response.data.data.datas.project_type_id == "1") {
          const responseData = await api.fetchAllData(
            token,
            "project-info",
            response.data.data.datas.id
          );
          commit("setData", responseData);
          if (responseData.status == 200) {
            router.push("/budget");
          }
        } else {
          const responseData = await api.fetchAllData(
            token,
            "project-info",
            response.data.data.datas.id
          );
          commit("setData", responseData);
          if (responseData.status == 200) {
            router.push("/budget2");
          }
        }
      }
    }
  },

  async storeOrUpdateBudget({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    // console.log(response);
    if (response.status == 200) {
      commit("setData", response);
      if (response.status == 200) {
        const responseData = await api.fetchAllData(
          token,
          "project-info-details",
          response.data.data.data.id
        );
        commit("setData", responseData);
        if (responseData.status == 200) {
          router.push(`/${response.data.data.data.id}/project-preview`);
        }
      }
    }
  },

  async storeOrUpdateProjectModify({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    commit("setData", response);
    // console.log(response);
    if (response.status == 200) {
      if (response.data.data.datas.project_type_id == 2) {
        router.push("/edit-address");
      } else {
        var project_id_modify = JSON.parse(
          localStorage.getItem("project_id_modify")
        );
        if (response.status == 200) {
          if (response.data.data.datas.has_pre_survey == 1) {
            const responseData = await api.fetchAllData(
              token,
              "pre-survey-question-json",
              project_id_modify
            );
            commit("setData", responseData);
            router.push("/edit-pre-survey-question");
          } else {
            const responseData = await api.fetchAllData(
              token,
              "question-json",
              project_id_modify
            );
            commit("setData", responseData);
            router.push("/edit-question");
          }
        }
      }
    }
  },

  async storeOrUpdateAddressModify({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    // console.log(response);
    if (response.status == 200) {
      // commit("setData", response);
      // router.push("/edit-question")

      if (response.data.data.datas.has_pre_survey == 1) {
        const responseData = await api.fetchAllData(
          token,
          "pre-survey-question-json",
          response.data.data.datas.id
        );
        commit("setData", responseData);
        router.push("/edit-pre-survey-question");
      } else {
        const responseData = await api.fetchAllData(
          token,
          "question-json",
          response.data.data.datas.id
        );
        commit("setData", responseData);
        router.push("/edit-question");
      }
    }
  },

  async storeOrUpdatePreSurveyQuestionModify(
    { rootState, commit },
    parameters
  ) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    // console.log(response);
    if (response.status == 200) {
      commit("setData", response);
      router.push("/edit-question");
    }
  },

  async storeOrUpdateQuestionModify({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    // console.log(response);
    if (
      response.status == 200 &&
      response.data.data.datas.project_type_id == 3
    ) {
      commit("setData", response);
      router.push("/edit-assign-agent-groups-to-project");
    } else {
      commit("setData", response);
      router.push("/edit-assign-teams-to-project");
    }
  },

  async storeOrUpdateProjectAgentAssignmentModify(
    { rootState, commit },
    parameters
  ) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    if (response.status == 200) {
      commit("setData", response);
      if (response.status == 200) {
        const responseData = await api.fetchAllData(
          token,
          "project-info",
          response.data.data.datas.id
        );
        commit("setData", responseData);
        // if (responseData.status == 200) {
        //   router.push("/edit-budget");
        // }
        if (response.data.data.datas.agentTaskAssignmentMethod == 3) {
          router.push("/edit-define-project-task-to-agent");
        } else {
          router.push("/edit-budget");
        }
      }
    }
  },
  async storeOrUpdateTeamAssignmentModify({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    // console.log(response);
    if (response.status == 200) {
      commit("setData", response);
      if (response.status == 200) {
        if (
          response.data.data.datas.dasher_category_id == "1" &&
          response.data.data.datas.project_type_id == "1"
        ) {
          router.push("/edit-filtering");
        } else if (
          response.data.data.datas.dasher_category_id == "2" &&
          response.data.data.datas.project_type_id == "1"
        ) {
          router.push("/edit-budget");
        } else if (
          response.data.data.datas.dasher_category_id == "2" &&
          response.data.data.datas.project_type_id == "2"
        ) {
          router.push("/edit-budget2");
        } else if (
          response.data.data.datas.dasher_category_id == "1" &&
          response.data.data.datas.project_type_id == "2"
        ) {
          router.push("/edit-budget2");
        }
      }
    }
  },
  async storeOrUpdateFilterDasherModify({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    // console.log(response);
    if (response.status == 200) {
      commit("setData", response);
      if (response.status == 200) {
        if (response.data.data.datas.project_type_id == "1") {
          router.push("/edit-budget");
        } else {
          router.push("/edit-budget2");
        }
      }
    }
  },
  async storeOrUpdateBudgetModify({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    // console.log(response);
    if (response.status == 200) {
      commit("setData", response);
      if (response.status == 200) {
        const responseData = await api.fetchAllData(
          token,
          "project-info-details",
          response.data.data.data.id
        );
        commit("setData", responseData);
        if (responseData.status == 200) {
          router.push("/edit-project-preview");
        }
      }
    }
  },

  async storeOrUpdateErrorHandler({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeDataErrorHandler(
      token,
      parameters[0],
      parameters[1]
    );
    // if (!response)
    // console.log(response.response.status);

    commit("setData", response);
    // commit('setTest', response)
    // router.push('/budget')
  },
  async modifyProject({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    commit("setData", response);
  },

  async storePayment({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    // commit("setTest", response);
    if (response.data != undefined) {
      // console.log();
      window.open(response.data, "_self");
    } else {
      alert("Undefined port pos redirect api");
    }
  },
  async newTransaction({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    commit("setData", response);
    if (response.data.error == 0) {
      router.push("all-project");
    } else {
      router.push("payment-page");
    }
  },
  async remainingTransaction({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    commit("setData", response);
    if (response.data.error == 0) {
      router.push("all-project");
    } else {
      router.push("remaining-payment-page");
    }
  },
  async checkDasher({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    // commit("setTest", response);
    commit("setFilter", response);
    // router.push('/budget')
  },
  async projectGoToLive({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    commit("setData", response);
    if (response.data.error == 0) {
      router.push("/project-list");
    }
  },

  async projectSubmission({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    // console.log(response);
    commit("setResponse", response);
    // commit("setTest", response);
    if (response.data.error == 0) {
      JSON.stringify(localStorage.setItem("project_id", null));
      JSON.stringify(localStorage.setItem("project_id_edit", null));
      localStorage.setItem(
        "submitted_project_id",
        response.data.data.project_id
      );
      router.push("/client-view");
    }
  },

  async delete({ rootState, commit }, parameters) {
    const { token } = rootState.auth;
    const response = await api.deleteData(token, parameters[0], parameters[1]);
    commit("setData", response);
  },
  async cancelProjectBeforePay({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.changeDataStatus(
      token,
      parameters[0],
      parameters[1]
    );
    commit("setData", response);
    if (response.data.error == 0) {
      router.push("/all-project");
    } else {
      router.push("/project-details");
    }
  },
  async pauseOrResumeProjectStatus(
    { rootState, commit, dispatch },
    parameters
  ) {
    // commit('setTest', parameters)
    commit("setIndexDataLoading", true);
    const { token } = rootState.auth;
    const response = await api.changeDataStatus(
      token,
      parameters[0],
      parameters[1]
    );
    commit("setData", response);
    commit("setIndexDataLoading", false);
    dispatch("projectStatusCount", ["project-status-count"]);
    // if (response.data.error == 1) {
    //   router.push("/all-project");
    // }
  },
  async editedTask({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    commit("setData", response);
    // router.push('/task')
  },
  async updateRequest({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    commit("setData", response);
    // router.push('/task')
  },
  async modifyTransaction({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    commit("setData", response);
    // router.push('/task')
  },
  async getProjectDetails({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.changeDataStatus(
      token,
      parameters[0],
      parameters[1]
    );
    commit("setData", response);
    if (response.data.error == 1) {
      router.push("/all-project");
    } else {
      window.localStorage.setItem("project_details_by_id", parameters[0]);
      router.push("/project-details").catch((err) => err);
    }
  },
  async getProjectReportDetails({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.changeDataStatus(
      token,
      parameters[0],
      parameters[1]
    );
    commit("setData", response);
    // if (response.data.error == 1) {
    //   router.push("/project-summary-report");
    // } else {
    //   window.localStorage.setItem("project_details_by_id1", parameters[0]);

    //   router.push(`/${parameters[0]}/project-report-details`).catch((err) => err);
    // }
  },
  async getDasherReportDetails({ rootState, commit }, parameters) {
    // commit('setTest', parameters)
    const { token } = rootState.auth;
    const response = await api.changeDataStatus(
      token,
      parameters[0],
      parameters[1]
    );
    commit("setData", response);
    if (response.data.error == 1) {
      router.push("/dasher-summary-report");
    } else {
      window.localStorage.setItem("dasher_id", parameters[0]);
      if (parameters[3] != "") {
        router.push(parameters[3]).catch((err) => err);
      }
    }
  },
  async getCashOutReport({ rootState, commit }, parameters) {
    // commit('setTest', parameters)
    const { token } = rootState.auth;
    const response = await api.getCashOutDetails(
      token,
      parameters[0],
      parameters[1],
      parameters[2],
      parameters[3]
    );
    commit("setData", response);
  },
  async getSubmittedProject({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.changeDataStatus(
      token,
      parameters[0],
      parameters[1]
    );
    commit("setData", response);
  },
  async modifySurvey({ rootState, commit }, parameters) {
    // commit('setTest', parameters)
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    commit("setResponse", response);
    // console.log(response);
    // commit("setTest", response);
    if (response.data.error == 0) {
      JSON.stringify(localStorage.setItem("project_id_modify", null));
      router.push("/all-project");
    } else {
      router.push("/edit-project-preview");
    }
  },

  async getProjectResponse({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.changeDataStatus(
      token,
      parameters[0],
      parameters[1]
    );
    commit("setData", response);
    if (response.data.error != 0) {
      router.push("/project-details");
    }
    window.localStorage.setItem("projectId", parameters[0]);
    router.push("/task-status");
  },
  async getProjectReportResponse({ rootState, commit }, parameters) {
    // commit('setTest', parameters)
    JSON.stringify(localStorage.setItem("projectIdForResponse", parameters[0]));
    const { token } = rootState.auth;
    const response = await api.fetchReportResponseData(
      token,
      parameters[0],
      parameters[1]
    );
    commit("setData", response);
    if (response.data.error != 0) {
      router.push("/project-report-details");
    }
    window.localStorage.setItem("projectId", parameters[0]);
    if (parameters[2] != "responseData")
      router.push("/project-report-response");
  },
  async getPaginatedIndexData({ rootState, commit, dispatch }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    commit("setIndexDataLoading", true);
    const response = await api.getIndexDataByPagination(
      token,
      parameters[0],
      parameters[1],
      parameters[2],
      parameters[3],
      parameters[4],
      parameters[5],
      parameters[6]
    );
    commit("setData", response);
    dispatch("projectStatusCount", ["project-status-count"]);
    commit("setIndexDataLoading", false);
  },
  async changeProjectStatus({ rootState, commit }, parameters) {
    // commit('setTest', parameters)
    const { token } = rootState.auth;
    const response = await api.getProjectDataByPagination(
      token,
      parameters[0],
      parameters[1],
      parameters[2],
      parameters[3],
      parameters[4],
      parameters[5]
    );
    commit("setData", response);
  },
  async changeTaskStatus({ rootState, commit }, parameters) {
    // commit('setTest', parameters)
    const { token } = rootState.auth;
    const response = await api.getResponsedDataByPagination(
      token,
      parameters[0],
      parameters[1],
      parameters[2],
      parameters[3],
      parameters[4],
      parameters[5]
    );
    commit("setData", response);
  },
  async changeTaskStatusWithSearch({ rootState, commit }, parameters) {
    // commit('setTest', parameters)
    const { token } = rootState.auth;
    const response = await api.getResponsedDataByPaginationWithSearch(
      token,
      parameters[0],
      parameters[1],
      parameters[2],
      parameters[3],
      parameters[4]
    );
    commit("setData", response);
  },
  async changePendingTaskStatus({ rootState, commit }, parameters) {
    // commit('setTest', parameters)
    const { token } = rootState.auth;
    const response = await api.getAcceptResponse(
      token,
      parameters[0],
      parameters[1],
      parameters[2]
    );
    commit("setData", response);
  },
  async changeNidStatus({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.getNidDataByPagination(
      token,
      parameters[0],
      parameters[1],
      parameters[2],
      parameters[3],
      parameters[4]
    );
    commit("setData", response);
  },

  async changeDasherTeamStatus({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.getDasherTeamDataByPagination(
      token,
      parameters[0],
      parameters[1],
      parameters[2],
      parameters[3],
      parameters[4]
    );
    // console.log(response);
    commit("setData", response);
  },

  async changeDasherTeamVerificationStatus({ rootState, commit }, parameters) {
    // commit('setTest', parameters)
    const { token } = rootState.auth;
    const response = await api.changeVerificationStatus(
      token,
      parameters[0],
      parameters[1]
    );
    // console.log(response);
    commit("setData", response);
  },

  async changeWithdrawStatus({ rootState, commit }, parameters) {
    // commit("setTest", parameters);
    const { token } = rootState.auth;
    const response = await api.getWithdrawalDataByPagination(
      token,
      parameters[0],
      parameters[1],
      parameters[2],
      parameters[3],
      parameters[4]
    );
    commit("setData", response);
  },

  async changeBalanceWithdrawStatus({ rootState, commit }, parameters) {
    // commit("setTest", parameters);
    const { token } = rootState.auth;
    const response = await api.getBalanceWithdrawalStatus(
      token,
      parameters[0],
      parameters[1],
      parameters[2],
      parameters[3],
      parameters[4],
      parameters[5]
    );
    commit("setData", response);
  },

  async exportData({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.getExportData(
      token,
      parameters[0],
      parameters[1]
    );
    // commit("setData", response);
    commit("setTest", response);
  },

  async changePaymentStatus({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.changeDataStatusByPagination(
      token,
      parameters[0],
      parameters[1],
      parameters[2],
      parameters[3],
      parameters[4]
    );
    commit("setData", response);
  },

  async disbursedAmount({ rootState, commit }, parameters) {
    // commit('setTest',parameters)
    const { token } = rootState.auth;
    const response = await api.transDocuments(
      token,
      parameters[0],
      parameters[1],
      parameters[2]
    );
    commit("setData", response);
  },
  setErrorZero({ commit }) {
    commit("setErrorToZero");
  },
  setSuccessZero({ commit }) {
    commit("setSuccessToZero");
  },
};

const mutations = {
  setData: (state, responseData) => {
    // state.test = responseData;
    if (responseData.data.error == 1) {
      state.statusCode = responseData.data.statusCode;
      state.error = responseData.data.error;
      state.success = responseData.data.success;
      state.errorMsg = responseData.data.errorMsg;
    } else {
      state.error = responseData.data.error;
      state.success = responseData.data.success;
      state.statusCode = responseData.data.statusCode;
      state.errorMsg = responseData.data.errorMsg;
      state.indexData = responseData.data.data;
    }
  },
  setProjectStatusCount: (state, responseData) => {
    // state.test = responseData;
    if (responseData.data.error == 1) {
      state.statusCode = responseData.data.statusCode;
      state.error = responseData.data.error;
      state.success = responseData.data.success;
      state.errorMsg = responseData.data.errorMsg;
    } else {
      state.error = responseData.data.error;
      state.success = responseData.data.success;
      state.statusCode = responseData.data.statusCode;
      state.errorMsg = responseData.data.errorMsg;
      state.projectStatusCount = responseData.data.data;
    }
  },
  setIndexDataLoading: (state, response) => {
    state.indexDataLoading = response;
  },
  setSubscriptionData: (state, responseData) => {
    state.subscriptionData = responseData.data.data.subscriptionData;
    // if (responseData.data.error == 1) {
    //   state.statusCode = responseData.data.statusCode;
    //   state.error = responseData.data.error;
    //   state.errorMsg = responseData.data.errorMsg;
    // } else {
    //   state.error = responseData.data.error;
    //   state.statusCode = responseData.data.statusCode;
    //   state.errorMsg = responseData.data.errorMsg;
    //   state.indexData = responseData.data.data;
    // }
  },
  setResponse: (state, responseData) => {
    // state.test = responseData.data.error
    // console.log(responseData);
    if (responseData.data.error == 1) {
      state.statusCode = responseData.data.statusCode;
      state.error = responseData.data.error;
      state.success = responseData.data.success;
      state.errorMsg = responseData.data.errorMsg;
    } else {
      state.error = responseData.data.error;
      state.statusCode = responseData.data.statusCode;
      state.success = responseData.data.success;
      state.errorMsg = responseData.data.errorMsg;
      state.indexData = responseData.data.data;
    }
  },
  setErrorToZero: (state) => {
    state.error = 0;
  },
  setSuccessToZero: (state) => {
    state.success = 0;
  },
  setErrorMessage: (state, responseData) => {
    // console.log(responseData.data);
    state.error = 0;
    state.errorMsg = responseData.data.errorMsg;
    state.error = 0;
  },
  // setSuccessMessage: (state, responseData) => {
  //   // console.log(responseData.data);
  //   state.error = 0;
  //   state.errorMsg = responseData.data.errorMsg;
  //   state.error = 0;
  // },
  updateProjectData: (state, responseData) => {
    // state.test = responseData
    if (responseData.data.error == 1) {
      state.statusCode = responseData.data.statusCode;
      state.error = responseData.data.error;
      state.success = responseData.data.success;
      state.errorMsg = responseData.data.errorMsg;
    } else {
      state.error = responseData.data.error;
      state.statusCode = responseData.data.statusCode;
      state.success = responseData.data.success;
      state.errorMsg = responseData.data.errorMsg;
      state.indexData = responseData.data.data;
    }
  },
  setFilter: (state, responseData) => {
    // state.test = responseData.data.error
    if (responseData.data.error == 1) {
      state.statusCode = responseData.data.statusCode;
      state.error = responseData.data.error;
      state.success = responseData.data.success;
      state.errorMsg = responseData.data.errorMsg;
    } else {
      state.error = responseData.data.error;
      state.success = responseData.data.success;
      state.statusCode = responseData.data.statusCode;
      state.errorMsg = responseData.data.errorMsg;
      state.availableDasher = responseData.data.data;
    }
  },
  setTest: (state, credentials) => {
    state.test = credentials;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
